import { CdkPortalOutletAttachedRef, ComponentPortal, Portal } from '@angular/cdk/portal';
import { Component, ComponentRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Companies } from 'src/app/models/account.model';
import { LoginModel } from 'src/app/models/login.model';
import { ThirdPartyLogisticsService } from 'src/app/services/third-party-logistics.service';
import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { ShowCompanyDetailsPopupComponent } from '../../dialogs/show-company-details-popup/show-company-details-popup.component';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { CreateAppPopupComponent } from '../create-app-popup/create-app-popup.component';

@Component({
  selector: 'app-third-pl-marketplace-connection',
  templateUrl: './third-pl-marketplace-connection.component.html',
  styleUrls: ['./third-pl-marketplace-connection.component.scss']
})
export class ThirdPlMarketplaceConnectionComponent implements OnInit,OnDestroy {
  @Input() marketplace: string;
  @Input() companies: Companies[];
  @Input() connectedCompanies: Companies[];
  @Output() refresh: EventEmitter<boolean> = new EventEmitter();
  selectedPortal: Portal<any>;
  componenetPortal = {   
    nineyard3pl: new ComponentPortal(CreateAppPopupComponent),
  };
  isProductSelected: boolean = true;
  public account3plForm: FormGroup = new FormGroup({
    selectAccount: new FormControl('', Validators.required),
  });
  @ViewChild('panel') panel: MatExpansionPanel;
  private destroy$ = new Subject<void>();
  
  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private thirdPartyLogistics: ThirdPartyLogisticsService
    ) { }

  ngOnInit(): void {
    const user = JSON.parse(localStorage.getItem("User")) as LoginModel;
    user.isShipyard || user.isPriceYard || user.isYardener || user.isPlanYard || user.isNetYard
      ? (this.isProductSelected = true)
      : (this.isProductSelected = false);
      this.account3plForm.get("selectAccount").valueChanges.subscribe(selectedValue => {
        this.refreshAccounts();
      })
  }

  refreshAccounts() {
    this.selectedPortal = null
    setTimeout(() => {
      this.refresh.emit(true);
    }, 2500);
  }

  openAddConnection(event: MouseEvent, marketPlace?) {
    event.stopPropagation();
    if (marketPlace) {
      this.selectedPortal = this.componenetPortal[marketPlace.toLowerCase()];
    } else {
      this.selectedPortal = null;
    }
  }

  removeCompanies(companyId) {
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "600px",
        data: {
          title: "Remove 3PL Account",
          message: "Are you sure you want to remove this 3PL Account? This will unassign all the shipments assigned to this 3PL Account.",
          actions: [
            { text: "Cancel", buttonStyle: "underline" },
            { text: "Confirm", buttonColor: "accent", buttonStyle: "wire" },
          ],
        },
      })
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        const payload = {
          companyIds: [companyId]
        }
        this.thirdPartyLogistics.removeCompanies(payload).pipe(takeUntil(this.destroy$)).subscribe({
          next: (res) => {
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Removed company successfully',
                action: 'Dismiss',
                type: 'success',
              },
            }
        );
          this.refresh.emit();
        },
          error: (err) => {
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 4000,
                horizontalPosition: 'center',
                data: {
                  title: err.error.error,
                  action: 'Dismiss',
                  type: 'error',
                },
              }
          );
           }
         });
      });
  }

  showDetails(company){
    this.dialog
    .open(ShowCompanyDetailsPopupComponent, {
      width: "600px",
      data: {
        title: "Account Details",
        companyDetails: company
      },
    });
  }

  attach(ref: CdkPortalOutletAttachedRef) {
    ref = ref as ComponentRef<any>;

    if (ref.instance.close) {
      ref.instance.close.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.selectedPortal = null;
      });
    }

    if (ref.instance.saved) {
      ref.instance.saved.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.refreshAccounts();
        this.panel.open();
      });
    }
  }

  cancelEvent = (event: MouseEvent) => {
    event.stopPropagation();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
